import { Table } from "antd";
import styled from "styled-components";

export const TransferHistoryCustomTable = styled(Table)`
  margin-top: 20px;

  thead .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }
  .ant-table {
    overflow: hidden;
    border: 1px solid rgba(226, 232, 240, 1);
    border-radius: 10px;
  }
  .ant-table-tbody > tr:last-child > td {
    border-bottom: none !important;
  }

  tbody .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }
  .ant-table-thead > tr > th {
    background-color: white !important;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    color: rgba(49, 65, 88, 1);
  }

  .ant-table-tbody > tr:nth-child(odd) {
    background-color: rgba(226, 226, 247, 0.2);
  }

  .ant-table-tbody > tr:nth-child(even) {
    background-color: white;
  }

  @media (max-width: 1200px) {
    .ant-table-thead > tr > th {
      font-size: 14px;
    }

    .ant-table-tbody > tr > td {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th {
      font-size: 12px;
    }

    .ant-table-tbody > tr > td {
      font-size: 12px;
    }
  }
`;
